export const SERVICES = "Services";
export const PRODUCTS = "Products";
export const ADD_ON = "Add-On Plans";
export const SPECIAL = "Special";
